export default __webpack_public_path__ + "static/media/logo.dbf79a11.png";